import { TableColumn } from "react-data-table-component";
import { TFunction } from "i18next";
import { Badges } from "../../AbstractElements";
import { useTranslation } from "react-i18next";
 import {
  DropdownItem,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
} from "reactstrap";
import { MoreVertical } from "react-feather";
import { Link } from "react-router-dom";
import { showWarningAlert } from "../../utils/showWarningAlert";
import { useState } from "react";
import { UserListTableDataColumnType } from "../../types/users/UserTypes";
const RoleBadge = ({ status }: { status: string }) => (
  <Badges
    color="transparent"
    className={`badge-light-${
      status === "Fixed"
        ? "success"
        : status === "Pending"
        ? "warning"
        : status === "Verified"
        ? "danger"
        : "info"
    }`}
  >
    {status}
  </Badges>
);
const ErrorListTableAction: React.FC<{ row: UserListTableDataColumnType }> = ({
  row,
}) => {
   
  const { t } = useTranslation();
  const handleFixed = () => {
    showWarningAlert({
      title: t("Are you sure?"),
      text: `Do you want to Fixed ${row.url}?`,
      confirmButtonText: t("Confirm"),
      onConfirm: () => {
        // Block logic here
      },
    });
  };

  const handleVerified = () => {
    showWarningAlert({
      title: t("Are you sure?"),
      text: `Do you want to Verified ${row.url}?`,
      confirmButtonText: t("Confirm"),
      onConfirm: () => {
        // Unblock logic here
      },
    });
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="span" className="cursor-pointer">
        <MoreVertical size={18} />
      </DropdownToggle>
      <DropdownMenu>
        <Link to={`${process.env.PUBLIC_URL}/reports/view/${row.id}`}>
          <DropdownItem >{t("View")}</DropdownItem>
        </Link>
        {row.status === "Pending" && <DropdownItem onClick={handleFixed}>{t("Fixed")}</DropdownItem>}
        {row.status === "Fixed" && <DropdownItem onClick={handleVerified}>{t("Verified")}</DropdownItem>}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export const ErrorListColumn = (t: TFunction): TableColumn<any>[] => [
  {
    name: t("Sl.No"),
    selector: (row) => row.id,
    width: "70px",
    center: true,
  },
  {
    name: t("URL"),
    selector: (row) =>
      row.url,
      //   <a href={row.url} target="_blank" rel="noopener noreferrer">
      //     {row.url}
      //   </a>
    center: true,
    width: "150px",
  },
  {
    name: t("firstOccuranceTime"),
    selector: (row) => row.firstOccurrenceTime,
    center: true,
    width: "200px",
  },
  {
    name: t("secondOccuranceTime"),
    selector: (row) => row.lastOccurrenceTime,
    center: true,
    width: "200px",
  },
  {
    name: t("Type"),
    selector: (row) => row.type,
    center: true,
  },
  {
    name: t("Status"),
    selector: (row) => <RoleBadge status={row.status} />,
    center: true,
  },
  {
    name: t("Action"),
    cell: (row) => <ErrorListTableAction row={row} />,
    sortable: true,
  },
];
